import { Reducer } from "redux";

import { DiseaseTypeResponse } from "../models/Api/Master";
import { DiseaseTypeDispatchTypes } from "../models/DispatchTypes/Master";
import { DiseaseTypeActionDispatchTypes } from "../constants/Master";

const initialState: DiseaseTypeResponse = {
  loading: false,
  response: [],
};

const IcdCodeTypeReducer: Reducer<
  DiseaseTypeResponse,
  DiseaseTypeDispatchTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case DiseaseTypeActionDispatchTypes.GET_DISEASE_TYPE_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case DiseaseTypeActionDispatchTypes.GET_DISEASE_TYPE_SUCCESS: {
      return {
        ...state,
        response: action.response,
        loading: false,
      };
    }
    case DiseaseTypeActionDispatchTypes.GET_DISEASE_TYPE_ERROR: {
      return initialState;
    }
  }
  return state;
};

export default IcdCodeTypeReducer;
